import { render, staticRenderFns } from "./TableFilterSorter.vue?vue&type=template&id=d185147e&"
import script from "./TableFilterSorter.vue?vue&type=script&lang=js&"
export * from "./TableFilterSorter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports